'use strict';exports.__esModule = true;exports.israelCardholderId = exports.licenseNumber = exports.noTempMail = exports.notRequiredEmail = exports.email = exports.phoneNumber = exports.number = exports.required = exports.maxLength = exports.minLength = exports.ERRORS = undefined;var _constants = require('../constants');
var _validate = require('../utils/validate');
var _checkers = require('../utils/checkers');
var _checkIsraelCardholderId = require('../utils/checkIsraelCardholderId');var _checkIsraelCardholderId2 = _interopRequireDefault(_checkIsraelCardholderId);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var ERRORS = exports.ERRORS = {
  REQUIRED_FIELD: 'required',
  NUMBER: 'number',
  PHONE_NUMBER: 'phone-number',
  EMAIL: 'email',
  LICENSE_NUMBER: 'license-number',
  ISRAEL_ID: 'israel-id',
  TEMP_EMAIL: 'temp-email',
  MIN_LENGTH: 'min-length',
  MAX_LENGTH: 'max-length' };


var minLength = exports.minLength = function minLength(min) {var ending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;return function () {var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return value.length < min ? '' +
    ERRORS.MIN_LENGTH + (ending ? '-' + ending : '') :
    undefined;};};

var maxLength = exports.maxLength = function maxLength(max) {var ending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;return function () {var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return value.length > max ? '' +
    ERRORS.MAX_LENGTH + (ending ? '-' + ending : '') :
    undefined;};};


var required = exports.required = function required(value) {return !value ? ERRORS.REQUIRED_FIELD : undefined;};
var number = exports.number = function number(value) {return value && Number.isNaN(Number(value)) ? ERRORS.NUMBER : undefined;};
var phoneNumber = exports.phoneNumber = function phoneNumber(value) {return !_constants.phoneNumberRegex.test(value) ? ERRORS.PHONE_NUMBER : undefined;};
var email = exports.email = function email(value) {return !(0, _validate.emailRegexValidation)(value) ? ERRORS.EMAIL : undefined;};
var notRequiredEmail = exports.notRequiredEmail = function notRequiredEmail(value) {return value && !(0, _validate.emailRegexValidation)(value) ? ERRORS.EMAIL : undefined;};
var noTempMail = exports.noTempMail = function noTempMail(value) {return value && (0, _checkers.isTemporaryEmail)(value) ? ERRORS.TEMP_EMAIL : undefined;};
var licenseNumber = exports.licenseNumber = function licenseNumber(value) {return !(0, _validate.licenseNumberValidation)(value) ? ERRORS.LICENSE_NUMBER : undefined;};
var israelCardholderId = exports.israelCardholderId = function israelCardholderId(value) {return !(0, _checkIsraelCardholderId2.default)(value) ? ERRORS.ISRAEL_ID : undefined;};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/reduxFormValidators.js
// module id = 67
// module chunks = 0